const PARTY_LINEAGE_BY_KEY = Object.freeze({
  uniao: {
    canonicalKey: 'uniao',
    canonicalLabel: 'UNIÃO Brasil',
    aliases: ['UNIÃO', 'UNIAO', 'DEM', 'PSL'],
    note: 'Linhagem partidária: UNIÃO Brasil resultou da fusão de DEM e PSL.'
  },
  mobiliza: {
    canonicalKey: 'mobiliza',
    canonicalLabel: 'MOBILIZA',
    aliases: ['MOBILIZA', 'PMN'],
    note: 'Linhagem partidária: PMN passou a usar a marca MOBILIZA.'
  },
  agir: {
    canonicalKey: 'agir',
    canonicalLabel: 'AGIR',
    aliases: ['AGIR', 'PTC'],
    note: 'Linhagem partidária: PTC passou a usar a marca AGIR.'
  },
  podemos: {
    canonicalKey: 'podemos',
    canonicalLabel: 'PODE',
    aliases: ['PODE', 'PODEMOS', 'PTN'],
    note: 'Linhagem partidária: PTN passou a usar a marca PODEMOS/PODE.'
  }
});

const ALIAS_TO_KEY = Object.freeze(Object.values(PARTY_LINEAGE_BY_KEY).reduce((acc, entry) => {
  entry.aliases.forEach(alias => {
    acc[normalizePoliticalKey(alias)] = entry.canonicalKey;
  });
  return acc;
}, {}));

export function getPartyLineageInfo(label) {
  const key = normalizePoliticalKey(label);
  const canonicalKey = ALIAS_TO_KEY[key] || key;
  const entry = PARTY_LINEAGE_BY_KEY[canonicalKey];
  if (!entry) {
    return {
      canonicalKey,
      canonicalLabel: String(label || '').trim(),
      aliases: [String(label || '').trim()].filter(Boolean),
      note: ''
    };
  }
  return entry;
}

export function buildPoliticalDeltaData(rowsA = [], rowsB = []) {
  const map = new Map();
  const ensure = (row) => {
    const label = String(row?.nome || '').trim();
    const lineage = getPartyLineageInfo(label);
    const key = lineage.canonicalKey;
    if (!key) return null;
    if (!map.has(key)) {
      map.set(key, {
        key,
        nome: lineage.canonicalLabel || label,
        votosA: 0,
        votosB: 0,
        percentualA: 0,
        percentualB: 0,
        deltaVotos: 0,
        deltaPercentual: 0,
        lineageAliases: lineage.aliases || [],
        lineageNote: lineage.note || ''
      });
    }
    const item = map.get(key);
    if (lineage.canonicalLabel) item.nome = lineage.canonicalLabel;
    if (lineage.note) item.lineageNote = lineage.note;
    if (Array.isArray(lineage.aliases)) item.lineageAliases = Array.from(new Set([...item.lineageAliases, ...lineage.aliases]));
    return item;
  };

  rowsA.forEach(row => {
    const item = ensure(row);
    if (!item) return;
    item.votosA += Number(row.votos || 0);
    item.percentualA += Number(row.percentual || 0);
  });

  rowsB.forEach(row => {
    const item = ensure(row);
    if (!item) return;
    item.votosB += Number(row.votos || 0);
    item.percentualB += Number(row.percentual || 0);
  });

  return Array.from(map.values())
    .map(item => ({
      ...item,
      deltaVotos: item.votosB - item.votosA,
      deltaPercentual: item.percentualB - item.percentualA
    }))
    .sort((a, b) => Math.abs(b.deltaVotos) - Math.abs(a.deltaVotos) || b.votosB - a.votosB || a.nome.localeCompare(b.nome, 'pt-BR'));
}

function normalizePoliticalKey(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '')
    .toLowerCase();
}
